import CRASH88Actions from './CRASH88Actions'

export default class MAC88Actions extends CRASH88Actions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      platform: 'MAC88',
      gameType: 'LIVE',
      gameCode: 'MAC-LIVE-002',
    }

    this.gameName = 'Bacarrat'
  }
  // txnId: 5b3faa78-d65e-48af-8da0-e6506026f889
  // roundId: XBAC11761026718986
}
